import UploadImage from '@/components/upload-image/index.vue';
import CoreService from '@/core/core.service.js';
import { ticketDecrypt } from '@/utils/common.js';
import { mapGetters } from 'vuex';

export default {
  components: {
    UploadImage
  },
  data() {
    return {
      defaultImageList: [],
      imgUrl: ''
    };
  },
  computed: mapGetters([
    'ocrBoxInfo',
    'businessLicenseImage'
  ]),
  watch: {
    businessLicenseImage: {
      handler (list) {
        if (list.length) {
          this.imgUrl = list[0].fullpath;
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {
  },
  methods: {
    close () {
      const info = {
        show: false,
        step: 1
      };
      this.$store.commit('SET_OCR_BOX_INFO', info);
    },
    uploadSuccessImage (list) {
      this.$store.commit('SET_BUSINESS_LICENSE_IMAGE', list);
      if (list && list.length) {
        const info = {
          show: true,
          step: 3
        };
        this.$store.commit('SET_OCR_BOX_INFO', info);
        this.getOCRTicket();
      }
    },
    getOCRTicket() {
      CoreService.getOCRTicket().then(res => {
        const ticketInfo = ticketDecrypt(res);
        this.OCRIdentify(ticketInfo);
      });
    },
    OCRIdentify(ticketInfo) {
      const postData = {
        ...ticketInfo,
        imgUrl: this.imgUrl
      };
      CoreService.OCRIdentify(postData).then(res => {
        this.$store.commit('SET_BUSINESS_LICENSE_INFO', res);
      }).catch((error) => {
        this.$errorMessage(error.data);
        this.$store.commit('SET_BUSINESS_LICENSE_INFO', {});
      }).finally(() => {
        const info = {
          show: false,
          step: 1
        };
        this.$store.commit('SET_OCR_BOX_INFO', info);
      });
    }
  }
};
